import React from "react";
import { Upload, Image, Globe, Instagram, Facebook, Twitter, Save } from "lucide-react";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { Label } from "./ui/label";
import { Textarea } from "./ui/textarea";

export const OrganizerProfileTab = ({
  profile,
  setProfile,
  handleImageUpload,
  handleSaveProfile,
  uploading,
  logoRef,
  bannerRef
}) => {
  return (
    <div className="space-y-6">
      {/* Banner & Logo */}
      <div className="space-y-4">
        <div>
          <Label>Bannière</Label>
          <div 
            className="mt-2 h-32 rounded-lg overflow-hidden relative cursor-pointer group"
            style={{ backgroundColor: profile.theme_color + "30" }}
            onClick={() => bannerRef.current?.click()}
          >
            {profile.banner ? (
              <img src={profile.banner} alt="" className="w-full h-full object-cover" />
            ) : (
              <div className="absolute inset-0 flex items-center justify-center">
                <Upload className="w-8 h-8 text-muted-foreground group-hover:text-primary" />
              </div>
            )}
            <div className="absolute inset-0 bg-black/50 opacity-0 group-hover:opacity-100 flex items-center justify-center transition-opacity">
              <span className="text-white text-sm">Changer la bannière</span>
            </div>
          </div>
          <input
            ref={bannerRef}
            type="file"
            accept="image/*"
            onChange={(e) => handleImageUpload(e, "banner")}
            className="hidden"
          />
        </div>

        <div className="flex gap-4">
          <div>
            <Label>Logo</Label>
            <div 
              className="mt-2 w-20 h-20 rounded-full overflow-hidden relative cursor-pointer group bg-muted"
              onClick={() => logoRef.current?.click()}
            >
              {profile.logo ? (
                <img src={profile.logo} alt="" className="w-full h-full object-cover" />
              ) : (
                <div className="absolute inset-0 flex items-center justify-center">
                  <Image className="w-6 h-6 text-muted-foreground" />
                </div>
              )}
            </div>
            <input
              ref={logoRef}
              type="file"
              accept="image/*"
              onChange={(e) => handleImageUpload(e, "logo")}
              className="hidden"
            />
          </div>
          <div className="flex-1">
            <Label>Nom de l'organisation</Label>
            <Input
              value={profile.company_name}
              onChange={(e) => setProfile({ ...profile, company_name: e.target.value })}
              className="mt-2"
            />
          </div>
          <div>
            <Label>Couleur</Label>
            <Input
              type="color"
              value={profile.theme_color}
              onChange={(e) => setProfile({ ...profile, theme_color: e.target.value })}
              className="mt-2 w-16 h-10 p-1"
            />
          </div>
        </div>
      </div>

      <div>
        <Label>Description</Label>
        <Textarea
          value={profile.description}
          onChange={(e) => setProfile({ ...profile, description: e.target.value })}
          placeholder="Présentez votre organisation..."
          rows={4}
          className="mt-2"
        />
      </div>

      {/* Social Links */}
      <div className="space-y-3">
        <Label>Liens</Label>
        <div className="grid sm:grid-cols-2 gap-3">
          <div className="flex items-center gap-2">
            <Globe className="w-4 h-4 text-muted-foreground" />
            <Input
              value={profile.website}
              onChange={(e) => setProfile({ ...profile, website: e.target.value })}
              placeholder="https://monsite.com"
            />
          </div>
          <div className="flex items-center gap-2">
            <Instagram className="w-4 h-4 text-pink-500" />
            <Input
              value={profile.instagram}
              onChange={(e) => setProfile({ ...profile, instagram: e.target.value })}
              placeholder="@instagram"
            />
          </div>
          <div className="flex items-center gap-2">
            <Facebook className="w-4 h-4 text-blue-600" />
            <Input
              value={profile.facebook}
              onChange={(e) => setProfile({ ...profile, facebook: e.target.value })}
              placeholder="Facebook"
            />
          </div>
          <div className="flex items-center gap-2">
            <Twitter className="w-4 h-4 text-sky-500" />
            <Input
              value={profile.twitter}
              onChange={(e) => setProfile({ ...profile, twitter: e.target.value })}
              placeholder="@twitter"
            />
          </div>
        </div>
      </div>

      <Button onClick={handleSaveProfile} className="w-full" disabled={uploading}>
        <Save className="w-4 h-4 mr-2" />
        Enregistrer les modifications
      </Button>
    </div>
  );
};
